module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/schnurrbart-e8f29e32ac8c71c0d8f9d1b13e1e3098.svg";